/**
 * Premium Features — glassmorphism feature cards.
 * Vanilla JS, no external dependencies: click ripple feedback and a
 * scroll-triggered reveal (IntersectionObserver). All hover/light-sweep/
 * icon-nudge interactions are handled entirely in CSS.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRipple(root) {
    var wraps = root.querySelectorAll('[data-pf-card]');
    wraps.forEach(function (wrap) {
      var inner = wrap.querySelector('.pf-card');
      if (!inner) return;

      wrap.addEventListener('click', function (e) {
        if (reducedMotion) return;

        var rect = inner.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height) * 1.6;
        var ripple = document.createElement('span');
        ripple.className = 'pf-ripple';
        ripple.style.width = size + 'px';
        ripple.style.height = size + 'px';
        ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
        ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
        inner.appendChild(ripple);

        var cleanup = function () {
          if (ripple.parentNode) ripple.parentNode.removeChild(ripple);
        };
        ripple.addEventListener('animationend', cleanup);
        setTimeout(cleanup, 900);
      });
    });
  }

  function initReveal(root) {
    var wraps = Array.prototype.slice.call(root.querySelectorAll('[data-pf-card]'));
    if (wraps.length === 0) return;

    var revealEnabled = root.dataset.reveal !== 'false';

    if (reducedMotion || !revealEnabled || !('IntersectionObserver' in window)) {
      wraps.forEach(function (wrap) { wrap.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    wraps.forEach(function (wrap) { observer.observe(wrap); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pf-section]').forEach(function (root) {
      if (root._pfInit) return;
      root._pfInit = true;
      initRipple(root);
      initReveal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init when the section is added/re-rendered from the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();